import React, { FC } from "react";
import { View, Text, StyleSheet } from "react-native";

import Colors from "../../constants/Colors";
import FontStyles from "../../constants/FontStyle";
import StyledButton from "../StyledButton";
import StyledIcon from "../StyledIcon";

interface IProps {
  title?: string;
  summary: string;
  action?: Function;
  actionTitle?: string;
}

const EmptyView: FC<IProps> = ({ title, summary, action, actionTitle }) => {
  return (
    <>
      <View style={styles.emptyContainer}>
        <StyledIcon
          size={58}
          iconOnly
          iconName="shopping-bag" // alternatively use `package`
          iconColor={Colors.greyColor}
          style={{
            padding: 10,
          }}
          iconLibrary="Feather"
        />
        <Text style={styles.title}>{title}</Text>

        <Text style={styles.summary}>{summary}</Text>

        {actionTitle && action && typeof action === "function" ? (
          <StyledButton
            label={`${actionTitle}`}
            size="sm"
            action={action}
            style={{
              marginTop: 32,
              minHeight: 42,
            }}
          />
        ) : null}
      </View>
    </>
  );
};

EmptyView.defaultProps = {
  summary: "No data found.",
};

export default EmptyView;

const styles = StyleSheet.create({
  emptyContainer: {
    flexGrow: 1,
    justifyContent: "center",
    alignItems: "center",
    paddingHorizontal: 16,
    // backgroundColor: Colors.whiteColor
  },
  title: {
    ...FontStyles.dark,
    ...FontStyles.size16,
    ...FontStyles.lh20,
    ...FontStyles.bold,
    textAlign: "center",
    marginVertical: 8,
  },
  summary: {
    width: 215,
    color: Colors.shades._7,
    ...FontStyles.size13,
    ...FontStyles.lh18,
    ...FontStyles.normal,
    textAlign: "center",
  },
});
